import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader, Row, Col, ListGroupItem, ListGroup} from 'reactstrap';
import { Update_Bot_User_Role } from '../../../../slices/thunks';

const Edit_role_modal = ( { Bot_ID,User_Role, User_Group_ID , User_Name } ) => {

    const [modal_standard, setmodal_standard] = useState(false);
    const [user_role, setuser_role] = useState(User_Role)
    const dispatch = useDispatch()
    function tog_standard_edit_role() {
        setmodal_standard(!modal_standard);
    }



    const update_user_role = () =>{
        dispatch(Update_Bot_User_Role({Bot_ID, Users: [{User_Group_ID, Type: user_role}]}))
    }
        
        

  return (
    <>
      <Button className="bg-transparent" onClick={() => tog_standard_edit_role()}><i className='ri-pencil-line'></i></Button>
      {/* Default Modal */}
        <Modal id="myModal"
            isOpen={modal_standard}
            toggle={() => {
                tog_standard_edit_role();
            }}
        >
            <ModalHeader className="modal-title"
                id="myModalLabel" toggle={() => {
                    tog_standard_edit_role();
                }}> 
                <span>Edit Role</span> for <span>{User_Name}</span>
            </ModalHeader>
            <ModalBody>
                <div className='add_new_user_inner'>
                    <Row>
                        <Col md={12}>
                            <div className='user_name'>
                              <select onChange={(e)=>{
                                setuser_role(e.target.value)
                              }}  class="form-select mb-3" aria-label=".form-select-lg example">
                                   
                                <option selected={User_Role==='BotUser'} value="BotUser">Bot User</option>
                                <option selected={User_Role==='BotAdmin'} value="BotAdmin">Bot Admin</option>
                                <option selected={User_Role==='Viewer'} value="Viewer">Viewer</option>
                            </select>
                            </div>
                        </Col>
                        
                    </Row>    
                    <div className="modal-footer">               
                       
                        <Button
                            color="light"
                            onClick={() => {
                                tog_standard_edit_role();
                            }}
                        >
                            Close
                        </Button>
                        <Button
                            color="secondary"
                            onClick={update_user_role}
                        >
                            Save Changes
                        </Button>
                    </div>
                </div>
            </ModalBody>
            
        </Modal>
    </>
  )
}

export default Edit_role_modal
